// @flow
import { useHistory, useParams } from 'react-router-dom';
import React from 'react';
import { getLinkForOrganizationsPage } from '@streaming-projects/links';
import { getDeleteWithWarningHeaderAndBody } from '@src/common-utils/utils';
import { useDeleteTableFlowResourceMutation } from '@streaming-projects/service-definitions/streamingProjectsApi';
import { toastError, toastSuccess } from '@presentational/notifications/utils';
import { ConfirmModal } from '@presentational/modals/ConfirmModal';

export const SPTableFlowResourceDeleteWarningModal = ({
  isOpen,
  onClose,
  tableFlowResourceName,
  tableFlowResourceId,
  version = null,
}) => {
  const [deleteTableFlowResource] = useDeleteTableFlowResourceMutation();
  const { orgId } = useParams();
  const { push } = useHistory();
  const { header, headerBody } = getDeleteWithWarningHeaderAndBody(
    'Tableflow Resource',
    tableFlowResourceName
  );

  const onClickHandlerForOK = async () => {
    const { error } = await deleteTableFlowResource({
      tableFlowResourceId,
      orgId: orgId,
      payload: {
        version,
      },
    });
    if (error) {
      toastError(error);
    } else {
      toastSuccess('Tableflow Resource delete was successful!');
      push(getLinkForOrganizationsPage(orgId));
    }
  };

  return (
    <ConfirmModal
      body={headerBody}
      header={header}
      isOpen={isOpen}
      onClickHandlerForCancel={onClose}
      onClickHandlerForOK={onClickHandlerForOK}
    />
  );
};
